import React, { useState, ReactNode } from 'react';
import { usePlatform } from '../hooks/usePlatform';
import { useAuth } from './AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppContext } from './AppContext';

const queryClient = new QueryClient();

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [questionnaireAnswers, setQuestionnaireAnswers] = useState<Record<string, any>>(
    {},
  );

  const platform = usePlatform();
  const { token } = useAuth();

  const updateAnswer = (questionId: string, answer: any) => {
    setQuestionnaireAnswers((prevAnswers: Record<string, any>) => ({
      ...prevAnswers,
      [questionId]: answer,
    }));
  };

  const value = {
    platform,
    questionnaireAnswers,
    updateAnswer,
    token,
  };

  return (
    <QueryClientProvider client={queryClient}>
      <AppContext.Provider value={value}>{children}</AppContext.Provider>
    </QueryClientProvider>
  );
};
